import { ProfileType } from '../enums/ProfileType';

export const ProfileHelper = {

  profilesThatCanViewTransport: [ProfileType.Admin, ProfileType.Ecommerce, ProfileType.Vendor, ProfileType.Viewer],

  profilesThatCanManageTransport: [ProfileType.Admin, ProfileType.Ecommerce],

  profilesThatCanViewPendingInvoicingOrders: [ProfileType.Admin],

  profilesThatCanManageLocations: [ProfileType.Admin],

  profilesThatCanManageStateTransport: [ProfileType.Admin, ProfileType.Ecommerce],

  profilesThatCanSeeTransport: [ProfileType.Vendor, ProfileType.Viewer],

  profilesThatCanManageMultifocalRecipe: [null, undefined, ProfileType.Admin, ProfileType.Vendor],

  profilesThatCanFilterLocation: [null, undefined, ProfileType.Admin, ProfileType.Ecommerce],

  profilesThatCanEvolvePriscriptionState: [ProfileType.Admin, ProfileType.Ecommerce, ProfileType.Vendor],

  profilesThatCanEvolvePriscriptionStateInBatch: [ProfileType.Admin, ProfileType.Ecommerce],

  profilesThatCanEvolveOrderState: [ProfileType.Admin, ProfileType.Ecommerce, ProfileType.Vendor],

  profilesThatCanEvolveOrderStateInBatch: [ProfileType.Admin, ProfileType.Ecommerce],

  profilesThatCanManageNotifications: [ProfileType.Admin, ProfileType.Ecommerce],

  profilesThatCanAccessOtherOptions: [null, undefined, ProfileType.Admin, ProfileType.Ecommerce],

  profilesThatCanSeeSimpleTable: [],

  profilesThatCanFilterSeller: [null, undefined, ProfileType.Admin, ProfileType.Vendor],

  profilesThatCanFilterStates: [null, undefined, ProfileType.Admin, ProfileType.Ecommerce, ProfileType.Vendor],

  profilesThatCanFilterPrescriptionStates: [null, undefined, ProfileType.Admin, ProfileType.Ecommerce, ProfileType.Vendor],

  profilesThatCanFilterManyPrescriptionStates: [ProfileType.Admin, ProfileType.Ecommerce],

  profilesThatCanPrintLabels: [null, undefined, ProfileType.Admin, ProfileType.Ecommerce],

  canPrintLabels: (userProfile?: ProfileType | null) => {
    if (!userProfile) return true;

    return ProfileHelper.profilesThatCanPrintLabels.some(profile => profile && +profile === +userProfile);
  },

  profilesThatCanOrCannotSeeClientDeadlineColumns: [ProfileType.Vendor, ProfileType.Viewer],
  profilesThatCanAlwaysSeeClientDeadlineColumns: [ProfileType.Ecommerce, ProfileType.Admin, ProfileType.Viewer],

  profilesThatCanOrCannotSeeInternalDeadlineColumns: [ProfileType.Vendor, ProfileType.Viewer],
  profilesThatCanAlwaysSeeInternalDeadlineColumns: [ProfileType.Ecommerce, ProfileType.Admin, ProfileType.Viewer],

  profilesThatCanSeeFulfilledByColumn: [ProfileType.Ecommerce, ProfileType.Admin, ProfileType.Vendor],

  profilesThatCanSeeOrderDetails: [ProfileType.Ecommerce, ProfileType.Admin, ProfileType.Vendor, ProfileType.GlobalPicker, ProfileType.Viewer],

  profilesThatCanFilterSpecialTagAndAlert: [null, undefined, ProfileType.Admin, ProfileType.Ecommerce, ProfileType.Vendor],

  profilesThatCanSeeCustomerPhone: [ProfileType.Vendor],

  profilesThatCanPrintLensSeparationList: [ProfileType.Ecommerce, ProfileType.Admin],

  profilesThatCanManageProductGroups: [ProfileType.Ecommerce, ProfileType.Admin, ProfileType.Vendor],

  profilesThatCanFilterCustomerDeadline: [null, undefined, ProfileType.Admin, ProfileType.Vendor, ProfileType.Viewer],

  profilesThatCanFilterDeliveredOrder: [null, undefined, ProfileType.Admin, ProfileType.Vendor, ProfileType.Viewer],

  profilesThatCanFilterCustomer: [null, undefined, ProfileType.Admin, ProfileType.Vendor, ProfileType.Viewer],

  profilesThatCanFilterLensMaterial: [null, undefined, ProfileType.Admin, ProfileType.Ecommerce],

  profilesThatCanManageLensCuttingMachineIntegration: [ProfileType.Admin, ProfileType.Assembler, ProfileType.Ecommerce, ProfileType.Vendor],

  profilesThatCanPrintTSOWithCssBarcode: [ProfileType.Admin, ProfileType.Ecommerce],

  profilesThatCanPrintDanfeLabelWithNativeBarcode: [ProfileType.Admin, ProfileType.Ecommerce]
}